export default {
  icon: 'Icon',
  name: 'Name',
  description: 'Description',
  state: 'State',
  workspace: 'Workspace',
};
